export default __webpack_public_path__ + "static/results-b35c4e4d08fa693ace2f8014f2c451cb.jpg";